"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/require-default-props */
const react_1 = require("react");
const highcharts_1 = __importDefault(require("highcharts"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const merge_1 = __importDefault(require("lodash/merge"));
const Utils_1 = require("../../utils/Utils");
const StyleUtils_1 = require("../../utils/StyleUtils");
const Highchart_styles_1 = require("./styles/Highchart.styles");
const Highchart_1 = require("./Highchart");
const __DEV__ = process.env.NODE_ENV !== 'production';
exports.Chart = (0, react_1.forwardRef)((props, ref) => {
    const { id, className = '', testId, optionOverrides = {} } = props;
    const styles = (0, Highchart_styles_1.getHighchartStyles)();
    const dti = (0, Utils_1.getTestIdAttribute)(testId);
    const { options } = (0, Highchart_1.useHighchart)();
    const chartOptions = (0, react_1.useMemo)(() => {
        return (0, merge_1.default)(options, optionOverrides);
    }, [options, optionOverrides]);
    if (!options) {
        if (__DEV__) {
            console.error('`Chart` component must be a child of `Highchart` component');
        }
        return null;
    }
    const highchartRef = (0, react_1.useRef)(null);
    // TODO handle exports
    (0, react_1.useImperativeHandle)(ref, () => ({
        downloadCSV() {
            if (highchartRef.current) {
                highchartRef.current.chart.downloadCSV();
            }
        },
        exportChart(options) {
            if (highchartRef.current) {
                highchartRef.current.chart.exportChart(options);
            }
        },
        print() {
            if (highchartRef.current) {
                highchartRef.current.chart.print();
            }
        },
    }), []);
    (0, react_1.useEffect)(() => {
        if (highchartRef.current) {
            highchartRef.current.chart.update((0, merge_1.default)(options, optionOverrides));
            highchartRef.current.chart.redraw();
        }
    }, [chartOptions]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: id, className: (0, StyleUtils_1.classNames)('Highchart-chart-container-local', styles.container, className) }, dti, { children: (0, jsx_runtime_1.jsx)(highcharts_react_official_1.default, { ref: highchartRef, highcharts: highcharts_1.default, options: chartOptions, containerProps: {
                className: (0, StyleUtils_1.classNames)('Highchart-chart-chartContainer-local', styles.chartContainer),
            } }) })));
});
